/* unplugin-vue-components disabled */import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'DataCellTabs',
  props: /*#__PURE__*/_mergeModels({
    typeTab: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /*#__PURE__*/_mergeModels(["click-tab"], ["update:modelValue"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var mode = _useModel(__props, "modelValue");
    var props = __props;
    var _toRefs = toRefs(props),
      typeTab = _toRefs.typeTab;
    function onClickTab(data) {
      emit('click-tab', data.name);
    }
    return function (_ctx, _cache) {
      var _component_van_tab = _resolveComponent("van-tab");
      var _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createBlock(_component_van_tabs, {
        shrink: "",
        type: "card",
        class: "data-cell-tabs",
        active: mode.value,
        "onUpdate:active": _cache[0] || (_cache[0] = function ($event) {
          return mode.value = $event;
        }),
        onClickTab: onClickTab
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeTab), function (value, key) {
            return _openBlock(), _createBlock(_component_van_tab, {
              key: key,
              name: key,
              title: value,
              "title-class": "data-cell-tabs-title"
            }, null, 8, ["name", "title"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["active"]);
    };
  }
});